import {Observable, of} from 'rxjs';
import {CanActivate} from '@angular/router';
import {Injectable} from '@angular/core';
import {select, Store} from '@ngrx/store';
import * as fromRoot from '../reducers';
import {LoadContracts} from '../actions/contracts.actions';
import {catchError, filter, switchMapTo, take, tap} from 'rxjs/operators';

@Injectable()
export class ContractsGuard implements CanActivate {

  constructor(private store: Store<fromRoot.State>) {
  }

  public canActivate(): Observable<boolean> {
    return this.checkContracts()
      .pipe(
        switchMapTo(of(true)),
        catchError(() => of(false))
      );
  }

  checkContracts(): Observable<boolean> {
    return this.store.pipe(
      select(fromRoot.selectContractsLoaded),
      tap(isLoaded => {
        if (!isLoaded) {
          this.store.dispatch(LoadContracts());
        }
      }),
      filter(isLoaded => isLoaded),
      take(1)
    );
  }
}
